import { takeLatest, put, call } from 'redux-saga/effects';

import { findPropriedadeCadastro } from '../service';
import {
  FIND_PROPRIEDADE_CADASTRO,
  FIND_PROPRIEDADE_CADASTRO_PENDING,
  FIND_PROPRIEDADE_CADASTRO_SUCCESS,
  FIND_PROPRIEDADE_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaFindPropriedadeCadastro(action) {
  yield put({ type: FIND_PROPRIEDADE_CADASTRO_PENDING, id: action.id })

  try {

    const registro = yield call(findPropriedadeCadastro, action.id);

    yield put({ type: FIND_PROPRIEDADE_CADASTRO_SUCCESS, registro: registro })

  } catch (error) {

    yield put({ type: FIND_PROPRIEDADE_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchFindPropriedadeCadastro() {
  yield takeLatest(FIND_PROPRIEDADE_CADASTRO, sagaFindPropriedadeCadastro)
}
